import React, { useContext } from "react";
import { TheContext } from "../Context";
import CelebrityItemEdit from "./CelebrityItemEdit";
import CelebrityItemView from "./CelebrityItemView";

export default function CelebrityItem({ celeb }) {
  const { editCelebId } = useContext(TheContext);

  if (editCelebId === celeb.id) {
    return <CelebrityItemEdit celebRead={celeb} />;
  } else {
    return <CelebrityItemView celeb={celeb} />;
  }
}
